import { Location } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Archivo } from "@models/archivo.model";
import { TipoDocumento } from "@models/tipo-documento.model";
import { ErrorService } from "@services/error.service";
import { SessionService } from "@services/session.service";
import { StateService } from "@services/state.service";
import { BaseFuncionalidadComponent } from "@shared/base/base-funcionalidad.component";
import SiNo from "@shared/enums/si-no.enum";
import { WarningError } from "@shared/errors/custom.error";
import { assignToModel } from "@shared/utils/fieldsMap.utils";

@Component({
  selector: "app-tabla-prestador",
  templateUrl: "./tabla-prestador.component.html",
  styleUrls: ["./tabla-prestador.component.scss"],
})
export class TablaPrestadorComponent extends BaseFuncionalidadComponent {
  @Input() tiposDocumento: TipoDocumento[];
  @Input() documentos: Archivo[];
  @Input() expirada: boolean;

  @Output() clickVer = new EventEmitter<Archivo>();
  @Output() clickAgregar = new EventEmitter<TipoDocumento>();

  opcionSeleccionada: string = "";

  constructor(
    sessionService: SessionService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    stateService: StateService,
    private errorService: ErrorService
  ) {
    super(route, sessionService, location, router, stateService);
  }

  get tipos() {
    return this.setDocumentosIngresados();
  }

  private setDocumentosIngresados() {
    const tipos: TipoDocumento[] = []
    this.tiposDocumento.forEach(td => {
      const tipoDoc = assignToModel(TipoDocumento, structuredClone(td));
      tipoDoc.ingresado = 0;
      this.documentos.forEach(d => {
        if (d.tipo.codigo === td.codigo) {
          tipoDoc.ingresado = Number(d.id);
          tipos.push(tipoDoc);
        }
      });
      const doc = tipos.find(t => td.codigo === t.codigo);
      if (!doc && td.requerido === SiNo.si) tipos.push(tipoDoc);
    });
    return tipos;
  }

  get noRequeridos() {
    return this.tiposDocumento.filter((td) => td.requerido === SiNo.no);
  }

  documentoIngresado(tipoDocumento: number): boolean {
    return this.documentos.findIndex(d => d.tipo.codigo === tipoDocumento) !== -1;
  }

  goVerDocumento(idDocumento: number) {
    const documento = this.documentos.find(d => d.id === idDocumento);
    this.clickVer.emit(documento);
  }

  goAgregarDocumento(tipo: TipoDocumento) {
    this.clickAgregar.emit(tipo);
  }

  agregarOtroDocumento() {
    try {
      if (!this.opcionSeleccionada) throw new WarningError("Debe seleccionar un tipo de documento");
      const idTipoDocumento = Number(this.opcionSeleccionada);
      const tipo = this.tiposDocumento.find(td => td.codigo === idTipoDocumento);
      this.goAgregarDocumento(tipo);
    } catch (error) {
      this.errorService.handle(error);
    }
  }
}
